import axios            from "@/axios/axios";
import createDictionary from "@/helpers/createDictionary";

const colors = {
  1: 'info',
  2: 'primary',
  3: 'warning',
  4: 'success',
  5: 'danger',
};

export default createDictionary({
  loadData:          () => axios.get('acts_statuses'),
  transformResponse: ( list ) => {
    list.forEach(item => {
      item.color = colors[item.id];
    });
    return list;
  },
});
